export default __webpack_public_path__ + "static/media/multi-pitch.d6bfc826.png";